
import {InjectionToken} from "@angular/core";
import {AlertCommentModel} from "../_models/AlertCommentModel";
import {ModelKey} from "../../../models/ModelKey";
import {IController} from "../../../controllers/IController";

export const IT_ALERT_COMMENT_CONTROLLER = new InjectionToken<IAlertCommentController>('IT_ALERT_COMMENT_CONTROLLER');
export const MK_ALERT_COMMENT = new ModelKey<AlertCommentModel>('MK_ALERT_COMMENT');

export interface IAlertCommentController extends IController {

}
